import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {ActionColumn, ActionItem, NumberColumn, TextColumn} from '../../../../shared/Models/columns';
import {Grid} from '../../../../shared/Models/grid';
import {CollectionService} from '../../../Services/collection.service';
import {Collection} from '../../../Models/Collection';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {concat, Observable, of, Subject} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-collection-overview',
  templateUrl: './collection-overview.component.html',
  styleUrls: ['./collection-overview.component.scss']
})
export class CollectionOverviewComponent implements OnInit {

  public grid: Grid;
  public collectionId: number;
  public collectionName: string;
  public collections: Observable<Collection[]>;
  public collectionsinput$ = new Subject<string>();
  public collectionsLoading = false;
  public disableDeleteButton = false;

  @ViewChild('collectionRowDetail', {static: false}) collectionRowDetail: any;
  @ViewChild('deleteModal', {static: false}) deleteModal = null;

  constructor(private router: Router, private collectionService: CollectionService, private broadcastService: BroadcastService, private translateService: TranslateService) {
  }

  ngOnInit() {
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.collection.name',
          prop: 'name',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.attributes.model',
          prop: 'modelCount',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.user.status',
          prop: 'status',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => {
            switch (row) {
              case true:
                return this.translateService.instant('global.active');
              case false:
                return this.translateService.instant('global.inactive');
            }
          }
        },
        <NumberColumn>{
          name: 'doctrine.collection.position',
          prop: 'position',
          sortable: true,
          type: NumberColumn.type,
          translate: true,
          maxWidth: 100,
          minWidth: 100,
          change: (e, row) => {
            const position = {position: e.target.value};
            this.collectionService.setPosition(position, row.id).subscribe((res) => {
              this.broadcastService.broadcast('refreshGrid', 'getCollection');
            });
          },
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-eye fa-lg',
              tooltip: 'global.view',
              onclick: row => this.router.navigateByUrl('back-office/collection/' + row.id + '/show'),
              showCallback: row => row,
              btnClass: 'ripple light'
            },
            <ActionItem>{
              icon: 'fa fa-pencil fa-lg',
              tooltip: 'global.edit',
              onclick: row => this.router.navigateByUrl('back-office/collection/' + row.id),
              showCallback: row => row,
              btnClass: 'ripple light ms-1'
            },
            <ActionItem>{
              icon: 'fa fa-remove fa-lg',
              tooltip: 'global.remove',
              onclick: row => {
                this.collectionId = row.id;
                this.collectionName = row.name.bold();
                this.deleteModal.show();
                // return this.router.navigateByUrl('back-office/property/' + row.id + '/show');
              },
              showCallback: row => row,
              btnClass: 'ripple light ms-1'
            },
          ]
        }
      ],
      service: this.collectionService,
      rememberURL: this.router.url,
      method: 'getCollection',
      defaultSort: 'position',
      rowDetailTemplate: this.collectionRowDetail,
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'asc',
      showButton: true,

    };
  }

  goToArchive() {
    this.router.navigateByUrl('back-office/collection/archive');

  }

  public softDelete() {
    this.disableDeleteButton = true;
    this.collectionService.softDeleteCollection(this.collectionId).subscribe((res) => {
      this.broadcastService.broadcast('refreshGrid', 'getCollection');
      this.deleteModal.hide();
      this.disableDeleteButton = false;
    });
  }
}
